var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n'], ['\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 0 3rem 3rem 0;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: left;\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n  h5,p {\n    padding-top: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  button {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n'], ['\n  padding: 0 3rem 3rem 0;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: left;\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n  h5,p {\n    padding-top: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  button {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component } from 'react';
import styled from 'styled-components';
import { Row, Col } from 'react-flexa';
import Button from '../../StyledComponents/Button';
var Container = styled.div(_templateObject);
var TextContainer = styled.div(_templateObject2);

var Cta11 = function (_Component) {
  _inherits(Cta11, _Component);

  function Cta11() {
    _classCallCheck(this, Cta11);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Cta11.prototype.render = function render() {
    var _props = this.props,
        title = _props.title,
        body = _props.body,
        button = _props.button;
    return React.createElement(Container, null, React.createElement('h4', null, title), React.createElement(Row, {
      justifyContent: 'center',
      alignItems: 'center'
    }, React.createElement(Col, {
      xs: 12,
      sm: 12,
      md: 4
    }, React.createElement(TextContainer, null, React.createElement('p', null, body[0]))), React.createElement(Col, {
      xs: 12,
      sm: 12,
      md: 4
    }, React.createElement(TextContainer, null, React.createElement('p', null, body[1]))), React.createElement(Col, {
      xs: 12,
      sm: 12,
      md: 4
    }, React.createElement(TextContainer, null, React.createElement(Button, {
      size: 'medium',
      colour: 'primary',
      onClick: function onClick() {
        return window.location.assign(button.url);
      }
    }, button.label)))));
  };

  return Cta11;
}(Component);

export default Cta11;